export default [
    {
        path: '/playground',
        name: 'playground',
        component: () => import('vcomponents/pages/PlaygroundComponent.vue'),
    },
];
